import React from "react";

import { observer } from "mobx-react";
import dynamic from "next/dynamic";
import * as PropTypes from "prop-types";

const classicComponent = dynamic(() => import("./overlays/Classic"));
const customComponent = dynamic(() => import("./overlays/Custom"));

function VideoOverlay({
  children,
  isPaused,
  setIsPaused,
  overlayColor,
  videoHeroType,
  overlayBackground,
  isPauseable,
}) {
  const OverlayComponent =
    videoHeroType === "classic" ? classicComponent : customComponent;

  return (
    <OverlayComponent
      isPauseable={isPauseable}
      isPaused={isPaused}
      overlayBackground={overlayBackground}
      overlayColor={overlayColor}
      setIsPaused={setIsPaused}
    >
      {children}
    </OverlayComponent>
  );
}

VideoOverlay.defaultProps = {
  children: null,
  isPauseable: false,
  isPaused: true,
  overlayBackground: "rgba(0, 0, 0, 0.25)",
  overlayColor: "transparent",
  setIsPaused: null,
  videoHeroType: "classic",
};

VideoOverlay.propTypes = {
  children: PropTypes.element,
  isPauseable: PropTypes.bool,
  isPaused: PropTypes.bool,
  overlayBackground: PropTypes.string,
  overlayColor: PropTypes.string,
  setIsPaused: PropTypes.func,
  videoHeroType: PropTypes.string,
};

export default observer(VideoOverlay);
